import { getCsrfToken, setCsrfToken } from "atlas_forecasting_app/lib/csrf"

export async function apiFetch(path, { method = "GET", body, headers = {} } = {}) {
  const requestHeaders = { Accept: "application/json", ...headers }
  const options = { method, headers: requestHeaders, credentials: "same-origin" }

  if (method !== "GET" && method !== "HEAD") {
    requestHeaders["X-CSRF-Token"] = getCsrfToken()
    requestHeaders["Content-Type"] = "application/json"
    if (body !== undefined) options.body = JSON.stringify(body)
  }

  const response = await fetch(path, options)
  const responseCsrfToken = response.headers.get("X-CSRF-Token")
  if (responseCsrfToken) setCsrfToken(responseCsrfToken)
  if (response.status === 204) return null

  const contentType = response.headers.get("content-type") || ""
  const data = contentType.includes("application/json") ? await response.json() : await response.text()

  if (!response.ok) {
    const message = typeof data === "string" ? data : data?.message || data?.error || `Request failed (${response.status})`
    const error = new Error(message)
    error.status = response.status
    error.data = data
    throw error
  }

  return data
}
